import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import rte, { command } from '../rte.js'
import input from '@mailobj-browser/front/js/events/types/input.js'
import all from '@mailobj-browser/front/js/selectors/all.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import selectInput from './selectInput/selectInput.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'

const onInput = object(listener, {
	type: input,
	passive,
	task: (
		select
	) => {
		const { style, value } = select
		const form = closest('form', select)
		const rte = one('iframe[data-rte]', form)

		if (rte && rte.id) {
			style.fontSize = value
			command(rte.id, 'fontsize', value)
		}
	}
})

const find = (
	select,
	size
) => {
	const template = one('template', select)
	const { content } = template
	const inputs = all('input', content)
	
	for (const input of inputs) {
		const { value } = input
		
		if (value === size) {
			return object(null, {
				input,
				template
			})
		}
	}
}

const size = (
	text = null,
	body = null
) => {
	if (text) {
		const font = closest('font[size]', text)
		
		if (font) {
			return font.size ?? ''
		}
	}
	
	const { dataset } = body
	const { fontSize } = dataset
	
	return fontSize
}

export const highlight = (
	select,
	modifier,
	text = null,
	body = null
) => {
	const match = find(select, size(text, body))
	
	if (!match) {
		return
	}
	
	const { input, template } = match
	
	selectInput(select, template, input)
	select.classList.add(modifier)
}

export default select => {
	const { style, value } = select

	style.fontSize = value
	onInput.listen(select)
	rte(select, object(null, { highlight }))
}
